export default __webpack_public_path__ + "static/media/logo.afce0873.png";